import attendance from './attendance'
import stagger from './stagger'

export default{
    attendance,
    stagger
}